import { Component, Inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { KeyValuePipe, NgForOf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { SidenavContentRef } from '../../shared/sidenav/sidenav-content/sidenav-content-ref';
import { SIDENAV_CONTENT_DATA } from '../../shared/sidenav/sidenav-content/sidenav-content.service';
import { ButtonSpacerDirective } from '../../shared/directives/button.directive';
import { originalOrderFunction } from '../../../../functions/original-order';
import { MatRadioModule } from '@angular/material/radio';
import { CapitalizePipeModule } from '../../../../pipes/format/capitalize.module';
import { TableFilters } from '../../../../models/entities/table-filters';
import { FormStatus } from '../../../../enums/form-status.enum';
import { SidenavContentModule } from '../../shared/sidenav/sidenav-content/sidenav-content.module';

export interface RequestFormFiltersSidenavInput {
    filters: TableFilters;
}

export interface RequestFormFiltersSidenavOutput {
    success: true;
    filters: TableFilters;
}

@Component({
    selector: 'app-form-filters-sidenav',
    templateUrl: './request-form-filters-sidenav.component.html',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        KeyValuePipe,
        MatButtonModule,
        ButtonSpacerDirective,
        NgForOf,
        MatRadioModule,
        CapitalizePipeModule,
        SidenavContentModule,
    ],
})
export class RequestFormFiltersSidenavComponent
{
    formGroup = this._fb.nonNullable.group({
        state: this.data.filters.state || 'active',
    });

    readonly formStatuses = FormStatus;
    readonly originalOrder = originalOrderFunction;

    constructor(
            private _fb: FormBuilder,
            private _sidenavRef: SidenavContentRef<RequestFormFiltersSidenavComponent>,
            @Inject(SIDENAV_CONTENT_DATA) public data: RequestFormFiltersSidenavInput,
    ) {
    }

    applyFilters() {
        const output: RequestFormFiltersSidenavOutput = {
            success: true,
            filters: this.formGroup.value,
        };
        this._sidenavRef.close(output);
    }
}
